import { Cookie } from "@modules/util/Cookie"
export async function addEventListenersToMyStarsFilterButtons() {
    const menuLinks = document.querySelectorAll(".lavert-card-header-menu a")
    const mainEl = document.querySelector('main[role="main"]')

    for (let i = 0; i < menuLinks.length; i++) {
        const link = menuLinks[i]

        link.addEventListener("click", (event) => {
            event.preventDefault() // prevent page reload

            const url = link.getAttribute("href") ?? ""
            const parts = url.split("/")
            let lastPart = (parts.pop() || parts.pop()) ?? ""
            const mobileParam = SiteInfo.isMobileVersion ? "?isMobile=true" : "?isMobile=false"
            const filters = ["alle", "aktiv", "abgelaufen", "bald-abgelaufen", "kein-fan"]
            if (!filters.includes(lastPart)) {
                lastPart = "alle"
            }

            fetch(`/api/my-stars/${lastPart}${mobileParam}`, {
                signal: AbortSignal.timeout(5000),
                credentials: "include",
            })
                .then((response) => {
                    if (response.status !== 200) {
                        throw new Error()
                    }
                    return response.json()
                })
                .then((data) => {
                    if (!data.content) return

                    if (mainEl) {
                        mainEl.innerHTML = data.content
                        addEventListenersToMyStarsFilterButtons() // reattach listeners
                    }
                })
                .catch((error) => {
                    throw new Error(`Error fetching my stars filter: ${error.message}`)
                })
        })
    }

    const container = document.querySelector(".slidemenu-stars-filter") as HTMLElement | null
    const activeEl = container?.querySelector(".active") as HTMLElement | null

    if (container && activeEl) {
        const scrollTo = activeEl.offsetLeft - container.offsetWidth / 2 + activeEl.offsetWidth / 2

        container.scrollTo({
            left: scrollTo,
            behavior: "smooth",
        })
    }
}

export function setNavigationCookieEventListeners() {
    const profileLinks = document.querySelectorAll(".star-profile-link")

    for (const x of profileLinks) {
        x.addEventListener("mousedown", () => {
            new Cookie("navigationCookie", {
                path: "/",
                expires: Cookie.getExpireDate(3600 * 24),
                domain: SiteInfo.cookieDomain,
                value: {
                    referrerTitle: "my-stars",
                    backlinkUrl: window.location.href,
                    searchHash: SiteInfo.currentSearchHash,
                    clickedAdvertId: x.getAttribute("data-star-id"),
                },
            })
        })
    }
}
